// routes
import { PATH_DashboardAndReportUser, PATH_HelpAndCommunication } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
// --------------------------------------------------------------------------------------------------------

const icon = (name) => (<SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />);

const ICONS = {
    dashboard: icon('ic_dashboard'),
    dataUpload: icon('ic_dataupload'),
    helpdesk: icon('communication'),
    master: icon('ic_master'),
    report: icon('ic_chart'),
    data: icon('ic_data'),
};

const navConfig = [
    //   GENERAL
    //   ----------------------------------------------------------------------
    {
        items: [
            { title: 'Dealer Sales Upload', path: PATH_DashboardAndReportUser.dataUploadApprove, icon: ICONS.dataUpload },
            { title: 'My Dealers Dashboard', path: PATH_DashboardAndReportUser.dealerlistpage, icon: ICONS.dashboard },
            { title: 'Help and Communication', path: PATH_HelpAndCommunication.helpandcommunication('JJ Core'), opneinnewtab: true, icon: ICONS.helpdesk },
            {
                title: 'Masters', path: PATH_DashboardAndReportUser.master.root, icon: ICONS.master,
                children: [
                    { title: 'Distributor', path: PATH_DashboardAndReportUser.master.distributor },
                    { title: 'Products', path: PATH_DashboardAndReportUser.master.product },
                    { title: 'ECP Product', path: PATH_DashboardAndReportUser.master.ecpproduct },
                    { title: 'Standard Price', path: PATH_DashboardAndReportUser.master.standardpricemaster },
                    { title: 'Accounts', path: PATH_DashboardAndReportUser.master.account },
                    { title: 'Area Tree', path: PATH_DashboardAndReportUser.master.areatree },
                    { title: 'Surgeons', path: PATH_DashboardAndReportUser.master.surgeon },
                    { title: 'Employee', path: PATH_DashboardAndReportUser.master.empmaster },
                    { title: 'Territory', path: PATH_DashboardAndReportUser.master.territory },
                    { title: 'Employee Territory', path: PATH_DashboardAndReportUser.master.empterritory },
                    { title: 'Territory Management', path: PATH_DashboardAndReportUser.master.accountterritory },
                    { title: 'Branch Secretary Region', path: PATH_DashboardAndReportUser.master.empregion },
                    { title: 'Distributor Territory', path: PATH_DashboardAndReportUser.master.distributorterritory },
                    { title: 'Territory Hierarchy', path: PATH_DashboardAndReportUser.master.territoryhierarchy },
                    { title: 'Organization Group ', path: PATH_DashboardAndReportUser.master.orggroupdefinition },
                    { title: 'Dealer Agreement', path: PATH_DashboardAndReportUser.master.dealeragreementexpiry },
                    { title: 'Dealer Rating ', path: PATH_DashboardAndReportUser.master.dealerrating },
                    { title: 'Distributor Billing Software', path: PATH_DashboardAndReportUser.master.distributorbillingsoftware },
                    { title: 'Customer', path: PATH_DashboardAndReportUser.master.customers },
                    { title: 'Customer Account', path: PATH_DashboardAndReportUser.master.customeraccount },
                ],
            },
            {
                title: 'Data', path: PATH_DashboardAndReportUser.data.root, icon: ICONS.data,
                children: [
                    { title: 'Inventory', path: PATH_DashboardAndReportUser.data.inventorypage },
                    { title: 'Gross Sales', path: PATH_DashboardAndReportUser.data.grosssalepage },
                ],
            },
            {
                title: 'Report', path: PATH_DashboardAndReportUser.report.root, icon: ICONS.report,
                children: [
                    { title: 'Dealer Data Status Report', path: PATH_DashboardAndReportUser.report.dealerdatastatusreportpage },
                    { title: 'Dealer Reported Sales', path: PATH_DashboardAndReportUser.report.transactionreportpage },
                    { title: 'Dealer Reported SNS', path: PATH_DashboardAndReportUser.report.dealerreportedsnsreportpage },
                    { title: 'Dealer Price Report', path: PATH_DashboardAndReportUser.report.dealerreportpage },
                    { title: 'My Sales Report', path: PATH_DashboardAndReportUser.report.salesreportpage },
                    { title: 'Request Report', path: PATH_DashboardAndReportUser.report.ytddumpreportpage },
                ],
            },
        ],
    }
];

export default navConfig;